<template>
  <div class="lg:!mx-0 flex">
    <div
      class="p-4 flex flex-col max-h-content w-screen min-h-content"
      :class="[expandedSection !== undefined ? 'space-y-0' : 'space-y-4']"
    >
      <div
        ref="packagesContainer"
        class="bg-white rounded-xl overflow-y-auto transition-[height] ease-linear relative "
        :class="[expandedSection === 'list' ? 'h-full border border-gray-300' : 'h-1/2 border border-gray-300', { '!h-0 !border-0': expandedSection === 'details'}]"
      >
        <div class="flex flex-col w-full">
          <!-- Header Section -->
          <div
            class="bg-white rounded-t-xl border-b border-gray-200 sticky top-0"
            :class="{ 'z-30': increaseZIndex }"
          >
            <div class="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-1.5 rounded-t-xl">
              <div class="flex items-center justify-between">
                <button
                  v-if="selectedPackage"
                  type="button"
                  @click="toggleListExpand"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-if="expandedSection === 'list'"
                   
                    class="w-6 h-6 text-gray-900/80 hover:text-gray-900 cursor-pointer transition-colors">
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25" />
</svg>

                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" v-else
                   
                    class="w-6 h-6 text-gray-900/80 hover:text-gray-900 cursor-pointer transition-colors">
  <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
</svg>
                </button>

                <h1 class="font-semibold text-gray-900 text-xl ml-4">
                  {{ $t('Subcontract.PackagesDashboard.title') }}
                </h1>

                <div class="flex items-center space-x-2 ml-4">
                  <div class="relative">
                    <AppInputIcon
                      v-model="searchForm.form.search"
                      type="text"
                      name="search"
                      class="form-input pl-10"
                      placeholder="Search packages..."
                    >
                      <template #icon>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-gray-400">
  <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
</svg>
                      </template>
                    </AppInputIcon>
                  </div>

                  <div class="relative">
                    <AppTypeAhead
                      v-model="subcontractorName"
                      name="subcontractor_name"
                      class="form-input pl-10"
                      placeholder="Filter by subcontractor..."
                      :suggestion-callback="getSuggestions"
                      :initial-suggestions="getSuggestions"
                      @value-selected="selectSupplier"
                    >
                      <template #icon>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-gray-400">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
</svg>
                      </template>
                    </AppTypeAhead>
                  </div>

                  <button
                    v-if="filterActive"
                    type="button"
                    class="btn btn--secondary-blue flex items-center space-x-2"
                    @click="resetSearch"
                  >
                    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>

                    <span>Clear</span>
                  </button>
                </div>

                <div class="flex items-center space-x-2 ml-auto">
                  <span class="text-sm font-medium text-gray-600">{{ $t('Subcontract.PackagesDashboard.sortBy') }}</span>

                  <AppSelect
                    v-model="sortColumn"
                    name="status_filter"
                    class="form-input pr-8 text-sm min-w-[140px]"
                    :options="sortOptions"
                    :empty-text="$t('Subcontract.PackagesDashboard.sort')"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Packages Table -->
          <table
            v-if="indexPackagesAction.firstLoad.value && fetchTradesAction.is(States.COMPLETE)"
            class="w-full border-separate border-spacing-0"
            :class="{ 'opacity-50': indexPackagesAction.is(States.LOADING) }"
          >
            <thead>
              <tr class="bg-gray-50 border-b border-gray-200 sticky top-0 z-10">
                <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('Subcontract.PackagesDashboard.package') }}
                </th>

                <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('Subcontract.PackagesDashboard.subcontractor') }}
                </th>

                <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('Subcontract.PackagesDashboard.contractReference') }}
                </th>

                <th class="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('Subcontract.PackagesDashboard.contractDate') }}
                </th>

                <th class="px-6 py-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('Subcontract.PackagesDashboard.budget') }}
                </th>

                <th class="px-6 py-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('Subcontract.PackagesDashboard.awardedValue') }}
                </th>

                <th class="px-6 py-4 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('Subcontract.PackagesDashboard.margin') }}
                </th>
              </tr>
            </thead>

            <tbody class="bg-white divide-y divide-gray-200">
              <tr
                v-for="projectPackage in filteredPackages"
                :key="projectPackage.id"
                class="cursor-pointer transition-colors duration-150"
                :class="[selectedPackageId === projectPackage.id ? 'bg-blue-50 border-l-4 border-blue-500' : 'hover:bg-gray-50']"
                @click="selectPackage(projectPackage, $event.target as HTMLElement)"
              >
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center space-x-3">
                    <button
                      v-if="project?.unarchived && falsey(projectPackage.locked_at)"
                      type="button"
                      class="btn-icon btn-icon-red"
                      @click.stop="deletePackage(projectPackage)"
                    >
                      <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
                    </button>

                    <div
                      v-if="projectPackage.locked_at"
                      class="btn-icon btn-icon-default"
                      title="Package has at least one claim and cannot be deleted."
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
</svg>
                    </div>

                    <div class="flex-1 min-w-0">
                      <p class="text-sm font-medium text-gray-900 truncate">
                        {{ projectPackage.name }}
                      </p>
                    </div>
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap">
                  <div
                    v-if="projectPackage.subcontractor_id"
                    class="text-sm text-gray-900"
                  >
                    <div class="font-medium">
                      {{ projectPackage.subcontractor.name }}
                    </div>

                    <div
                      v-if="projectPackage.subcontractor?.projects?.[0]?.contract_value && projectPackage.subcontractor?.$total_awarded"
                      class="text-xs text-gray-500 mt-1"
                    >
                      {{ australianCurrency(projectPackage.subcontractor.$total_awarded ?? 0) }} of {{ australianCurrency(projectPackage.subcontractor?.projects?.[0]?.contract_value ?? 0) }}
                    </div>

                    <div
                      v-else-if="falsey(projectPackage.subcontractor?.projects?.[0]?.contract_value)"
                      class="text-xs text-gray-500 mt-1"
                    >
                      Contract value not set
                    </div>
                  </div>

                  <div
                    v-else-if="project?.unarchived"
                    class="w-48"
                  >
                    <SubcontractorSelector
                      :package="projectPackage"
                      @click.stop=""
                    />
                  </div>

                  <div
                    v-else
                    class="text-sm text-gray-400"
                  >
                    Not assigned
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ projectPackage.contract_reference || '-' }}
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  <div v-if="projectPackage.contract_start_date && projectPackage.contract_end_date">
                    {{ new Date(projectPackage.contract_start_date).toLocaleDateString() }} to {{ new Date(projectPackage.contract_end_date).toLocaleDateString() }}
                  </div>

                  <div
                    v-else
                    class="text-gray-400"
                  >
                    Not set
                  </div>
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 text-right">
                  {{ $tcc(projectPackage.budgetWithAwardedWorks) }}
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 text-right">
                  {{ $tcc(projectPackage.totalAwarded) }}
                </td>

                <td
                  class="px-6 py-4 whitespace-nowrap text-sm font-medium text-right"
                  :class="[(projectPackage.budgetWithAwardedWorks - projectPackage.totalAwarded) >= 0 ? 'text-green-600' : 'text-red-600']"
                >
                  {{ $tcc(projectPackage.budgetWithAwardedWorks - projectPackage.totalAwarded) }}
                </td>
              </tr>

              <!-- Empty States -->
              <tr v-if="packages.length === 0 && indexPackagesAction.is(States.COMPLETE)">
                <td
                  colspan="7"
                  class="px-6 py-12 text-center"
                >
                  <div class="flex flex-col items-center">
                    <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                      <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-8 h-8 text-gray-400">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
</svg>
                    </div>

                    <h3 class="text-lg font-medium text-gray-900 mb-2">
                      {{ $t('Subcontract.PackagesDashboard.noPackagesFound') }}
                    </h3>

                    <p class="text-gray-500 mb-4">
                      Get started by adding your first package below.
                    </p>
                  </div>
                </td>
              </tr>

              <tr v-else-if="filteredPackages.length === 0 && indexPackagesAction.is(States.COMPLETE)">
                <td
                  colspan="7"
                  class="px-6 py-12 text-center"
                >
                  <div class="flex flex-col items-center">
                    <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 text-gray-400">
  <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
</svg>
                    </div>

                    <h3 class="text-lg font-medium text-gray-900 mb-2">
                      {{ $t('Subcontract.PackagesDashboard.noPackagesMatch') }}
                    </h3>

                    <p class="text-gray-500 mb-4">
                      Try adjusting your search or filter settings.
                    </p>

                    <button
                      type="button"
                      class="btn btn--secondary-blue"
                      @click="resetSearch"
                    >
                      {{ $t('Subcontract.PackagesDashboard.resetSearch') }}
                    </button>
                  </div>
                </td>
              </tr>


              <tr
                v-if="!filterActive && project?.unarchived"
                class="bg-gray-50 child:border-t child:border-gray-200 child:px-6 child:py-2 text-left sticky bottom-12 h-12"
              >
                <td colspan="100%">
                  <div class="flex items-center space-x-2">
                    <AppInput
                      v-model="packageform.form.name"
                      name="name"
                      type="text"
                      class="form-input py-1"
                      placeholder="Enter package name..."
                      @blur="createPackage"
                      @keyup.enter="$event.target.blur()"
                    />

                    <button
                      type="button"
                      class="btn btn--primary-blue flex items-center space-x-2 btn--small"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

                      <span>
                        {{ $t('Subcontract.PackagesDashboard.addPackage') }}
                      </span>
                    </button>
                  </div>
                </td>
              </tr>

              <tr
                v-if="!filterActive"
                class="child:border-t child:border-gray-200  child:px-6 child:py-2 text-xs sticky bottom-0 bg-gray-50 h-12"
              >
                <td class="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {{ $t('Subcontract.PackagesDashboard.total') }}
                </td>

                <td />

                <td />

                <td />

                <td class="text-right">
                  <span class="font-semibold text-gray-900">{{ australianCurrency(totalBudget) }}</span>
                </td>

                <td class="text-right">
                  <span class="font-semibold text-gray-900">{{ australianCurrency(totalAwarded) }}</span>
                </td>

                <td class="text-right">
                  <span
                    class="font-semibold"
                    :class="[totalProfit >= 0 ? 'text-green-600' : 'text-red-600']"
                  >
                    {{ australianCurrency(totalProfit) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="bg-white overflow-hidden">
            <!-- Loading State -->
            <div
              v-if="indexPackagesAction.is(States.LOADING)"
              class="flex justify-center items-center h-64"
            >
              <div class="flex flex-col items-center">
                <AppSpinner />

                <p class="mt-4 text-sm text-gray-500">
                  Loading packages...
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Package Details Section -->
      <Transition
        enter-active-class="animate__animated animate__fadeIn"
        leave-active-class="animate__animated animate__fadeOut"
        :css="enableAnimation"
      >
        <PackageBreakdown
          v-if="selectedPackage"
          class="transition-[height] ease-linear overflow-y-auto"
          :class="[expandedSection !== 'details' ? 'h-1/2' : 'h-full', {'!h-0 !p-0': expandedSection === 'list'}]"
          :selected-package="selectedPackage"
          :expanded="expandedSection === 'details'"
          @expand="toggleDetailsExpand"
          @shrink="toggleDetailsExpand"
        />
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import PackageBreakdown from '@/components/Subcontract/PackagesDashboard/PackageBreakdown.vue';
import SubcontractorSelector from '@/components/Subcontract/PackagesDashboard/SubcontractorSelector.vue';
import useBoqLockRedirect from '@/composables/useBoqLockRedirect';
import { useFormData } from '@/composables/useFormData';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { australianCurrency, falsey } from '@/helpers';
import { t } from '@/i18n';
import Package from '@/models/Package';
import { SupplierType } from '@/models/ProjectSupplier';
import { usePackagesStore } from '@/store/packages';
import { usePackageTradeItemsStore } from '@/store/packageTradeItems';
import { useProjectsStore } from '@/store/projects';
import { useSuppliersStore } from '@/store/supplier';
import { useTradesStore } from '@/store/trades';
import { useWbsCodesStore } from '@/store/wbsCodes';
import { useDebounceFn, useScroll } from '@vueuse/core';
import { useCollect } from 'pinia-orm/dist/helpers';
import Swal from 'sweetalert2';
import { computed, nextTick, ref, useTemplateRef, watch } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps<{
  projectId: string;
  packageId?: string;
}>();

const packagesStore = usePackagesStore();
const packageTradeItemsStore = usePackageTradeItemsStore();
const projectsStore = useProjectsStore();
const tradesStore = useTradesStore();
const wbsCodesStore = useWbsCodesStore();
const expandedSection = ref<undefined | 'list' | 'details'>(props.packageId ? undefined : 'list');
const enableAnimation = ref(true);

useBoqLockRedirect();

const toggleListExpand = () => {
  if(expandedSection.value !== 'list') {
    expandedSection.value = 'list';
  } else {
    expandedSection.value = undefined;
  }
};

const toggleDetailsExpand = () => {
  if(expandedSection.value !== 'details') {
    expandedSection.value = 'details';
  } else {
    expandedSection.value = undefined;
  }
};

const project = computed(() => {
  return projectsStore.project;
});

const packages = computed(() => {
  return packagesStore.models
    .where('project_id', project.value?.id)
    .with('package_trade_items', (query) => {
      query.with('trade_item');
    })
    .with('subcontractor', (query) => {
      query.with('projects', (query) => {
        query.where('project_id', project.value?.id)
          .with('supplier');
      });
    })
    .with('trade_items')
    .get();
});

const totalAwarded = computed(() => {
  return packages.value.reduce((total, currentPackage) => {
    return total + currentPackage.$total_awarded;
  }, 0);
});

const totalBudget = computed(() => {
  return packages.value.reduce((total, currentPackage) => {
    return total + currentPackage.budgetWithAwardedWorks;
  }, 0);
});

const totalProfit = computed(() => {
  return totalBudget.value - totalAwarded.value;
});

const selectedPackageId = ref<Id | undefined>();
const packagesContainer = useTemplateRef('packagesContainer');

const selectedPackage = computed(() => {
  return packages.value.find((projectPackage) => projectPackage.id === selectedPackageId.value);
});

const selectPackage = (packageToSelect: Package, row: HTMLElement) => {
  selectedPackageId.value = packageToSelect.id;
  expandedSection.value = undefined;

  nextTick(() => {
    const bounds = row.getBoundingClientRect();
    const containerRect = packagesContainer.value.getBoundingClientRect();

    // NOTE:
    // 90 is roughly the size of the add package row and totals row...
    // we could use ref and get exact height, but doesn't really matter
    // for now
    const isItemVisible = bounds.top >= (containerRect.top - 90) &&
      bounds.bottom <= (containerRect.bottom - 90);

    if(!isItemVisible) {
      row.scrollIntoView();
    }
  });
};

const selectPackageById = (packageId: Id) => {
  selectedPackageId.value = packageId;
  expandedSection.value = undefined;
};

const { y } = useScroll(packagesContainer);
const increaseZIndex = ref(true);

watch(y, (newValue) => {
  if(newValue > 0) {
    increaseZIndex.value = false;
  } else {
    increaseZIndex.value = true;
  }
});

const indexPackagesAction = useStoreApiAction(packagesStore.index);
const createPackageAction = useStoreApiAction(packagesStore.create);
const deletePackageAction = useStoreApiAction(packagesStore.delete);
const fetchTradesAction = useStoreApiAction(tradesStore.fetchTrades);
const indexWbsCodesAction = useStoreApiAction(wbsCodesStore.index);

watch(() => project.value?.id, (newValue, oldValue) => {
  if(newValue) {
    indexPackagesAction.request(newValue);
    fetchTradesAction.request(newValue, { boq_type: 'direct' });
    indexWbsCodesAction.request(newValue);

    if(oldValue && newValue !== oldValue) {
      enableAnimation.value = false;
      expandedSection.value = 'list';
    } else {
      if(props.packageId) {
        selectedPackageId.value = parseInt(props.packageId);
        expandedSection.value = undefined;
      } else {
        selectedPackageId.value = undefined;
        expandedSection.value = 'list';
      }
    }

    nextTick(() => {
      enableAnimation.value = true;
    });
  }
}, { immediate: true });

const packageform = useFormData({
  name: '',
});

const createPackage = () => {
  if(packageform.form.name && !createPackageAction.loading.value) {
    createPackageAction.request(project.value?.id, packageform.form)
      .then((newPackage) => {
        packageform.resetData();
        packagesContainer.value.scrollTop = packagesContainer.value.scrollHeight;
        selectPackageById(newPackage.id);
      });
  }
};

const deletePackage = (packageToDelete: Package) => {
  Swal.fire({
    icon: 'warning',
    title: t('Subcontract.PackagesDashboard.deletePackageTitle'),
    text: t('Subcontract.PackagesDashboard.deletePackageText', { name: packageToDelete.name }),
    showCancelButton: true,
  }).then((result) => {
    if(result.isConfirmed) {
      deletePackageAction.request(packageToDelete.id).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: t('Subcontract.PackagesDashboard.deletePackageError'),
        });
      });
    }

    if(selectedPackageId.value === packageToDelete.id) {
      selectedPackageId.value = undefined;
    }

    nextTick(() => {
      expandedSection.value = 'list';
    });
  });
};

const filteredPackageIds = ref<number[]>();
const subcontractorName = ref('');

const searchForm = useFormData({
  search: '',
  subcontractor: undefined,
});

const sortColumn = ref<'budget' | 'margin' | 'awarded_value' | 'created_at'>('created_at');

const sortOptions = computed(() => {
  const options = [
    {
      value: 'budget',
      label: t('Subcontract.PackagesDashboard.budget'),
    },
    {
      value: 'margin',
      label: t('Subcontract.PackagesDashboard.margin'),
    },
    {
      value: 'awarded_value',
      label: t('Subcontract.PackagesDashboard.awardedValue'),
    },
    {
      value: 'created_at',
      label: t('Subcontract.PackagesDashboard.dateCreated'),
    },
  ];

  return options;
});

const sortedPackages = computed(() => {
  let sortedPackages = [] as Package[];

  switch (sortColumn.value) {
    case 'budget':
      sortedPackages = useCollect(packages.value).sortBy((model) => -model.budgetWithAwardedWorks);

      break;

    case 'awarded_value':
      sortedPackages = useCollect(packages.value).sortBy((model) => -model.totalAwarded);

      break;

    case 'margin':
      sortedPackages = useCollect(packages.value).sortBy((model) =>
        -(model.budgetWithAwardedWorks - model.totalAwarded)
      );

      break;

    default:
      sortedPackages = packages.value;
      break;
  }

  return sortedPackages;
});

const searchPackages = () => {
  indexPackagesAction.request(project.value?.id, searchForm.form).then(({ data: packages }) => {
    filteredPackageIds.value = packages.map((filterPackage) => filterPackage.id);
  }).catch((error) => {
    console.log(error);
  });
};

const filteredPackages = computed(() => {
  if(!searchForm.isDirty.value) {
    return sortedPackages.value;
  }

  return sortedPackages.value.filter((sortedPackage) => {
    return filteredPackageIds.value?.includes(sortedPackage.id);
  });
});

const debounceSearch = useDebounceFn(searchPackages, 300);
const filterActive = ref(false);

watch(searchForm.form, (newValue) => {
  if(!newValue.search && !newValue.subcontractor) {
    filterActive.value = false;
    debounceSearch();
  } else {
    filterActive.value = true;
  }
});

const resetSearch = () => {
  filterActive.value = false;

  searchForm.resetData();

  searchPackages();
};

watch(searchForm.form, (newValue) => {
  if(filterActive.value) {
    debounceSearch();
  }
});

const suppliersStore = useSuppliersStore();
const suggestedSuppliers = ref<{ id: number; name: string }[]>([]);

const getSuggestions = async () => {
  suggestedSuppliers.value = await suppliersStore
    .search({
      name: subcontractorName.value ?? '',
      project_id: projectsStore.project.id,
      type: [SupplierType.subcontractor],
    });

  return suggestedSuppliers.value.map((value) => value.name);
};

const selectSupplier = (index: number) => {
  nextTick(() => {
    if(suggestedSuppliers.value[index]) {
      searchForm.form.subcontractor = suggestedSuppliers.value[index].id;
    }
  });
};

const router = useRouter();

watch(selectedPackageId, (newValue) => {
  if(newValue) {
    router.replace({ params: { packageId: newValue } });
  } else {
    router.replace({ params: { packageId: '' } });
  }
});
</script>

<style scoped></style>
